var _path, _rect, _path2, _rect2, _path3, _rect3, _rect4, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDmg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 522,
    viewBox: "0 0 435 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.425 0L435 115H38V0H322.425Z",
    fill: "#FAFAFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 115,
    width: 397,
    height: 407,
    fill: "#FAFAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 115H435L322.5 0V115Z",
    fill: "#DEE2E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 115,
    width: 97,
    height: 16,
    fill: "#E9ECEF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.323 123C135.027 172.113 170.627 224.708 214.5 279.291C275.856 355.627 338.19 411.736 396 452.359V459.791C396 477.464 381.673 491.791 364 491.791H110C92.3269 491.791 78 477.464 78 459.791V154.791C78 138.361 90.3819 124.824 106.323 123Z",
    fill: "#E9ECEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 278,
    height: 111,
    fill: "#0DCAF0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 131,
    width: 218,
    height: 31,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_1001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.0298 111H31.3707V41.1818H55.5071C62.4389 41.1818 68.3935 42.5795 73.3707 45.375C78.3707 48.1477 82.2117 52.1364 84.8935 57.3409C87.5753 62.5455 88.9162 68.7727 88.9162 76.0227C88.9162 83.2955 87.5639 89.5455 84.8594 94.7727C82.1776 100 78.3026 104.011 73.2344 106.807C68.1889 109.602 62.1207 111 55.0298 111ZM44.0185 100.057H54.4162C59.2798 100.057 63.3366 99.1705 66.5866 97.3977C69.8366 95.6023 72.2798 92.9318 73.9162 89.3864C75.5526 85.8182 76.3707 81.3636 76.3707 76.0227C76.3707 70.6818 75.5526 66.25 73.9162 62.7273C72.2798 59.1818 69.8594 56.5341 66.6548 54.7841C63.473 53.0114 59.5185 52.125 54.7912 52.125H44.0185V100.057ZM100.933 41.1818H116.411L137.138 91.7727H137.956L158.683 41.1818H174.161V111H162.024V63.0341H161.376L142.081 110.795H133.013L113.717 62.9318H113.07V111H100.933V41.1818ZM234.706 63.4773C234.138 61.6364 233.354 59.9886 232.354 58.5341C231.376 57.0568 230.195 55.7955 228.808 54.75C227.445 53.7045 225.876 52.9205 224.104 52.3977C222.331 51.8523 220.399 51.5795 218.308 51.5795C214.558 51.5795 211.217 52.5227 208.286 54.4091C205.354 56.2955 203.047 59.0682 201.365 62.7273C199.706 66.3636 198.876 70.7955 198.876 76.0227C198.876 81.2955 199.706 85.7614 201.365 89.4205C203.024 93.0795 205.331 95.8636 208.286 97.7727C211.24 99.6591 214.672 100.602 218.581 100.602C222.126 100.602 225.195 99.9205 227.786 98.5568C230.399 97.1932 232.411 95.2614 233.82 92.7614C235.229 90.2386 235.933 87.2841 235.933 83.8977L238.797 84.3409H219.842V74.4545H248.172V82.8409C248.172 88.8182 246.899 93.9886 244.354 98.3523C241.808 102.716 238.308 106.08 233.854 108.443C229.399 110.784 224.286 111.955 218.513 111.955C212.081 111.955 206.433 110.511 201.57 107.625C196.729 104.716 192.945 100.591 190.217 95.25C187.513 89.8864 186.161 83.5227 186.161 76.1591C186.161 70.5227 186.956 65.4886 188.547 61.0568C190.161 56.625 192.411 52.8636 195.297 49.7727C198.183 46.6591 201.57 44.2955 205.456 42.6818C209.342 41.0455 213.57 40.2273 218.138 40.2273C222.001 40.2273 225.604 40.7955 228.945 41.9318C232.286 43.0455 235.251 44.6364 237.842 46.7045C240.456 48.7727 242.604 51.2273 244.286 54.0682C245.967 56.9091 247.07 60.0455 247.592 63.4773H234.706Z",
    fill: "#FAFAFD"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_1001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.078 306.788C200.997 306.788 187.966 293.756 187.966 277.675C187.966 261.591 200.997 248.559 217.078 248.559C233.153 248.559 246.191 261.591 246.191 277.675C246.191 293.756 233.153 306.788 217.078 306.788ZM217.078 187.969C167.541 187.969 127.375 228.134 127.375 277.681C127.375 318.469 154.591 352.888 191.844 363.791L258.766 310.25L219.872 367.347C268.122 365.872 306.781 326.297 306.781 277.681C306.781 228.134 266.622 187.969 217.078 187.969ZM162.447 384.65L169.925 366.944L151.038 352.55L136.091 366.159V428.325L145.141 437.366H219.1V409.897H190.384L162.447 384.65Z",
    fill: "#CFF4FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.843 363.79L168.387 382.552L193.874 405.512L219.871 367.346L258.765 310.249L191.843 363.79ZM217.077 268.38C222.205 268.38 226.374 272.543 226.374 277.674C226.374 282.805 222.205 286.971 217.077 286.971C211.937 286.971 207.78 282.805 207.78 277.674C207.78 272.543 211.937 268.38 217.077 268.38ZM217.077 306.787C233.152 306.787 246.19 293.755 246.19 277.674C246.19 261.59 233.152 248.559 217.077 248.559C200.996 248.559 187.965 261.59 187.965 277.674C187.965 293.755 200.996 306.787 217.077 306.787ZM305.515 377.98L287.927 353.152L245.071 381.34L254.905 396.684L231.696 420.687L256.484 447.437L304.88 409.277L292.677 389.993L305.515 377.98Z",
    fill: "#0DCAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.077 268.382C211.937 268.382 207.78 272.545 207.78 277.676C207.78 282.807 211.937 286.973 217.077 286.973C222.205 286.973 226.374 282.807 226.374 277.676C226.374 272.545 222.205 268.382 217.077 268.382ZM219.871 367.348L193.874 405.513L168.387 382.554L191.843 363.791C154.59 352.888 127.374 318.47 127.374 277.682C127.374 228.135 167.54 187.97 217.077 187.97C266.621 187.97 306.78 228.135 306.78 277.682C306.78 326.298 268.121 365.873 219.871 367.348ZM304.88 409.279L256.484 447.438L231.696 420.688L254.905 396.685L245.071 381.341L287.927 353.154L305.515 377.982L292.677 389.995L304.88 409.279ZM219.099 437.366H145.14L136.09 428.326V366.16L151.037 352.551L169.924 366.945L162.446 384.651L190.384 409.898H219.099V437.366ZM303.63 182.082H130.521C125.324 182.082 121.074 186.332 121.074 191.526V446.732C121.074 451.926 125.324 456.173 130.521 456.173H303.63C308.821 456.173 313.074 451.926 313.074 446.732V191.526C313.074 186.332 308.821 182.082 303.63 182.082Z",
    fill: "#0AA2C0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_1001",
    x: 19.3711,
    y: 40.2266,
    width: 232.801,
    height: 87.7266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_1001"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_1001",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_1001"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "white",
    transform: "translate(67 169)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDmg);
export default __webpack_public_path__ + "static/media/dmg.90d96506b04b9b2f0dcf43fc106de062.svg";
export { ForwardRef as ReactComponent };